var map = {
	"./article/mentale-mure.json": 366,
	"./article/mure-i-historien.json": 367,
	"./article/mure-og-gadekunst.json": 368,
	"./article/mure-og-magt.json": 369,
	"./article/mure-og-miljo.json": 370,
	"./article/om.json": 371,
	"./case/australien-havene.json": 372,
	"./case/eu-og-middelhavet.json": 373,
	"./case/israel-og-palaestina.json": 374,
	"./case/sydafrika-og-zimbabwe.json": 375,
	"./case/usa-og-mexico.json": 376,
	"./index/index.json": 377,
	"./navigation/cases.json": 378,
	"./navigation/temaer.json": 379
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 180;



//////////////////
// WEBPACK FOOTER
// ./src/data ^\.\/.*\.json$
// module id = 180
// module chunks = 168707334958949